export default {
  set: ( name, value ) => localStorage.setItem( name, value ),
  get: ( name ) => localStorage.getItem( name ),
  clear: ( name ) => localStorage.removeItem( name ),
};
